import type { AuthPort } from '../ports/auth_port'

export class LogoutUseCase {
  private authPort: AuthPort

  constructor(authPort: AuthPort) {
    this.authPort = authPort
  }

  async execute(): Promise<void> {
    await this.authPort.logout()
  }
}
